// firebase.js - Complete Firebase Configuration
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBAZ_U0M1VpBNaHGjJ57c4HkGQS58weMks",
  authDomain: "vellego-app.firebaseapp.com",
  projectId: "vellego-app",
  storageBucket: "vellego-app.firebasestorage.app",
  messagingSenderId: "885678712807",
  appId: "1:885678712807:web:ec0a24810c316170f0bf42"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and get a reference to the service
export const auth = getAuth(app);

// Initialize Cloud Firestore and get a reference to the service
export const db = getFirestore(app);

// Initialize Cloud Storage and get a reference to the service
export const storage = getStorage(app);

export default app;